import TrackerNewDataActions from "./TrackerNewDataActions";
import TrackerNewDataHeader from "./TrackerNewDataHeader";
import { permissions } from "../../../plugins/permissions";
import TimeInput from "../../ui/TimeInput";

export const trackerNewDataCommon = {
    props: ["editTarget", "goal", "customization", "saving"],
    mixins: [permissions],
    components: {
        TimeInput,
        TrackerNewDataActions,
        TrackerNewDataHeader,
    },
    computed: {
        isoDate() {
            return this.date ? this.moment(this.date, "MM-DD-YY").format("YYYY-MM-DD") : null;
        },
    },
};
